import React from 'react'

function TextSwitch({a,b,isA,onSwitch}){    
    return(
    <div
      onClick={()=>{onSwitch(!isA)}}
      style={{
          border:isA ?
              '1px solid rgb(150 0 0 / 64%)' :
              '1px solid rgb(0 150 0 / 64%)',
          animation:'1s',
          fontSize:12,
          cursor:'pointer',
          verticalAlign:'middle',
          borderRadius:12,
          ['padding' + (isA ? 'Right' : 'Left')]: 14,
          display:'inline-flex',
          flexDirection:isA ? 'row' : 'row-reverse',
          // background:isA ?
          //     'rgba(255,0,0,0.1)' :
          //     'rgba(0,255,0,0.1)',
        }}>
          <div style={{
            display:'inline-block',
            width:22,            
            height:22,
            verticalAlign:'middle',
            borderRadius:'50%',
            ['margin' + (isA ? 'Right' : 'Left')]: 5,
            background:isA ? 'red' : 'green',
            border:'1px solid rgba(0,0,0,0.3)',
            opacity:0.8,
          }}>&nbsp;</div>
        <span style={{paddingTop:1}}>
        {isA && a}
        {!isA && b}       
        </span>
    </div>)
}
export default TextSwitch